/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 * Toast notifications - Simple alert-based notification system
 * Updated: 2026-01-09
 */

export const showToast = {
  success: (message: string) => {
    console.log(`✅ ${message}`);
    alert(message);
  },
  error: (message: string) => {
    console.error(`❌ ${message}`);
    alert(`Lỗi: ${message}`);
  },
  info: (message: string) => {
    console.info(`ℹ️ ${message}`);
    alert(message);
  },
  warning: (message: string) => {
    console.warn(`⚠️ ${message}`);
    alert(message);
  },
};
